import React from "react";
import { Link } from "react-router-dom";
import "../App.css";

const Check = () => {
  return (
    <div className="check-container">
      <Link to="/" className="home-link">Home</Link>
      <div className="check-content">
          <p>If this questionnaire is not anonymous, please log in using your own email address. Otherwise, click on 'Proceed'.</p>
          <div className="button-container">
            <Link to="/login" className="back-to">back to login</Link>
            <Link to="/form/anoniem@hr.nl" className="proceed">proceed</Link>
          </div>
      </div>
    </div>
  );
};

export default Check;
